import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { translate } from 'react-i18next';
import { theme } from 'lib/styles';

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-items: center;
	cursor: pointer;
`;

const Label = styled.label`
	font-size: 12px;
`;

const Indicator = styled.div`
	width: 48px;
	height: 24px;
	margin: 0 8px;
	border: 2px solid ${props => props.isOn ? props.theme.main : 'rgb(150,150,150)'};
	border-radius: 12px;
	position: relative;
	transition: border 0.2s ease-out;
`;

const Ball = styled.div`
	width: 16px;
	height: 16px;
	border-radius: 10px;
	background-color: ${props => props.isOn ? props.theme.main : 'rgb(150,150,150)'};
	position: absolute;
	top: 2px;
	left: ${props => props.isOn ? 25 : 2}px;
	transition: background-color 0.2s ease-out;
`;

const Toggle = props => {
	const { t, isOn, onChange } = props;

	return (
		<ThemeProvider theme={theme}>
			<Container onClick={() => onChange(!isOn)}>
				<Label style={{ justifySelf: 'start' }}>{t('general/toggle/no')}</Label>
				<Indicator isOn={isOn}>
					<Ball isOn={isOn} />
				</Indicator>
				<Label style={{ justifySelf: 'end' }}>{t('general/toggle/yes')}</Label>
			</Container>
		</ThemeProvider>
	)
}

Toggle.propTypes = {
	t: PropTypes.func,
	isOn: PropTypes.bool,
	onChange: PropTypes.func,
}

export default translate('translations')(Toggle)
